export default {
    namespaced: true,
    state: {
        items: {
            registration: [
                {
                    name: 'Koľko stojí založenie a vedenie investičného účtu?',
                    description: 'Otvorenie ako aj zrušenie investičného účtu je bezplatné. Vedenie investičného účtu je spoplatnené podľa aktuálneho ',
                    linkedText: 'sadzobníka poplatkov.',
                    link: 'https://www.sympatia.sk/wp-content/uploads/2020/11/Cenník-pre-riadenie-portfólia_FO-od-1.5.2019-1.pdf'
                },
                {
                    name: 'Kedy budem môcť začať investovať?',
                    description: 'Váš investičný účet bude pripravený k investovaniu najneskôr do dvoch pracovných dní od dokončenia registrácie. ' +
                        'Registráciu môžete kedykoľvek prerušiť a následne sa k nej do 30 dní vrátiť.\n'
                },
                {
                    name: 'Aké údaje budete odo mňa požadovať?',
                    description: 'Pri Vašej registrácii budeme potrebovať Vaše osobné údaje, číslo Vášho bankového účtu ' +
                        'spolu so skenom/fotografiou Vášho občianskeho preukazu a jedného ďalšieho dokladu slúžiaceho ' +
                        'na potvrdenie Vášho trvalého bydliska (faktúra, výpis z bankového účtu, atď.).'
                },
            ],
            login: [
                {
                    name: 'Zabudol som svoje heslo',
                    description: 'V prípade, že ste zabudli svoje heslo, nás neváhajte kontaktovať e-mailom na adrese ' +
                        'sales@sympatia.sk alebo telefonicky na čísle +421 2 3263 0713.'
                },
                {
                    name: 'Mám možnosť otvoriť si investičný účet aj osobne?',
                    description: 'Samozrejme, veľmi radi Vás privítame v našom sídle na Vajnorskej 21A, Bratislava ' +
                        'a pomôžeme Vám s otvorením Vášho účtu. Pre dohodnutie osobného stretnutia nás, prosím, ' +
                        'kontaktujte e-mailom na adrese sales@sympatia.sk alebo telefonicky na čísle +421 2 3263 0713.'
                },
            ],
            personalInfo: [
                {
                    name: 'Prečo musím zadať požadované osobné údaje?',
                    description: 'Požadované osobné údaje sú podľa platnej legislatívy nevyhnutné ' +
                        'k vytvoreniu zmluvnej dokumentácii k investičnému účtu.'
                },
                {
                    name: 'Prečo potrebujete číslo môjho bankového účtu?',
                    description: 'V rámci boja proti praniu špinavých peňazí nám naše smernice umožňujú prijímanie vkladov ' +
                        'a realizovanie výberov výlučne na Vami uvedený bankový účet, ktorý musí byť v banke vedený na Vaše meno.'
                },
                {
                    name: 'Kde sa dočítam viac o ochrane a spracúvaní mojich osobných údajov?',
                    description: 'Viac informácií nájdete na stránke ',
                    linkedText: ' www.sympatia.sk/gdpr.',
                    link: 'https://www.sympatia.sk/gdpr/'
                },
            ],
            investmentQuestionnaire: [
                {
                    name: 'Čo ak sa neskôr zmenia moje investičné očakávania?',
                    description: 'Vyplnenie investičného dotazníka budeme od Vás požadovať na pravidelnej báze. ' +
                        'V prípade akejkoľvek významnejšej zmeny Vašej životnej situácie či investičných postojov ' +
                        'Vám odporúčame požiadať o jeho opätovné vyplnenie.'
                },
            ],
            selectStrategy: [
                {
                    name: 'Mám možnosť investovať aj do iných investičných nástrojov?',
                    description: 'V rámci služby riadenia portfólia Vám umožňujeme okrem produktov ' +
                        'Sympatie investovať aj do zahraničných akcií a dlhopisov podľa Vášho výberu. ' +
                        'Naši investičný manažéri s Vami Váš výber radi prekonzultujú a poskytnú Vám naše odporúčania.'
                },
                {
                    name: 'Z Vašej ponuky si neviem vybrať žiaden produkt.',
                    description: 'V prípade, že Vašim očakávaniam nezodpovedá žiaden z ponúkaných produktov,' +
                        'môžete v registrácii pokračovať bez výberu. Po jej dokončení Vás bude kontaktovať ' +
                        'náš investičný manažér a predstaví Vám ďalšie možnosti.'
                },
            ],
            documents: [
                {
                    name: 'Prečo Vám musím tieto dokumenty poslať?',
                    description: 'Tieto dokumenty slúžia výlučne na overenie Vašej identity,' +
                        'ktoré je vyžadované platnou legislatívou.'
                },
            ],
        }
    },
    getters: {},
    actions: {},
    mutations: {}
};
